import React from 'react'
import { t } from 'lib/i18n-react'
import CoachMark from 'src/ui/CoachMark/CoachMark'
import UnitListItem from 'src/pages/MyCourse/subcomponents/UnitListItem/UnitListItem'

const MyCourseUnitListItem = (props) => {
  const unitItem = <UnitListItem {...props} />

  if (props.progress?.isCurrent) {
    return (
      <CoachMark
        name="coach_mark:current_unit_in_my_course"
        title={t('Lesson & Study Progress')}
        description={t(
          "For every level, see how much you've completed as you take Live Lessons and study for each unit."
        )}
        align="below"
        trackIfInSpotlight // it will add `inCoachMarkSpotlight` prop to Item component
        sx={{
          display: 'block',
        }}
      >
        {unitItem}
      </CoachMark>
    )
  }

  return unitItem
}

export default MyCourseUnitListItem
